// extracted by mini-css-extract-plugin
module.exports = {"simulate":"styles_simulate__DIuYE","wrapper":"styles_wrapper__S7Jws"};